// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"9563d10aa5a6bac69099","293":"20a55123c6bcc51f4122","518":"f504a75f5472b0971dec","779":"1b230e9b4ff97ffc93f8"}[chunkId] + ".js";
};